<template>
	<div>
		<Header />
    	<router-view/>
		<Footer />
	</div>
</template>

<script>
import Vue from 'vue'
import { mapActions, mapState, mapMutations } from 'vuex';

import Header from '../Header';
import Footer from '../Footer';
import deneme from '@/stores/deneme';

export default {
	components: {
		Header,
		Footer
	},

	data() {
		return {
			
		};
	},
	
	created() {
		
	},

	methods: {

	}
	
}
</script>
